<template>
  <div class="animated fadeIn">
    <global-table
      :table-data="advanceDetailItem"
      :loading="loadingParam"
      :per-page="10"
      :bordered="true"
      :table-detail="tableDetail"
      :hover="true"
      :striped="false"
      :fields="fields"
      :row-edit="employeeAdvanceItemForm"
      :redirect-detail="false"
      :show-add-button="true"
      caption="<i class='fa fa-align-justify'></i> Pengajuan Kasbon"
      addButton="Buat Pengajuan"
      @resetForm="resetForm"
      @editForm="editForm"
    ></global-table>

    <b-modal
      ref="myModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Tambah Pengajuan Kasbon</h3>
      </div>

      <b-form id="employeeAdvanceItemForm" validated novalidate>
        <div v-if="!loadingSubmitModal">
          <b-row>
            <b-col sm="4">
              <b-form-group label-for="title" label="Title">
                <b-form-input
                  id="title"
                  type="text"
                  v-model="$v.employeeAdvanceItemForm.title.$model"
                  :state="!$v.employeeAdvanceItemForm.title.$invalid"
                  required
                  placeholder="Title"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Title harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label-for="amount" label="Amount">
                <b-form-input
                  id="amount"
                  type="number"
                  v-model="$v.employeeAdvanceItemForm.amount.$model"
                  :state="!$v.employeeAdvanceItemForm.amount.$invalid"
                  required
                  placeholder="Amount"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Amount harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <loading></loading>
        </div>
      </b-form>

      <div slot="modal-footer" class="float-right">
        <div v-if="!loadingSubmitModal">
          <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
            <i class="fa fa-undo"></i> Back </b-button
          >&nbsp;
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="saveProcess"
            :disabled="$v.employeeAdvanceItemForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
export default {
  name: "employee-advance-item-detail",
  components: { loading, ModelSelect, MultiSelect, loading, globalTable },
  data() {
    return {
      employeeAdvanceItemForm: _interfaces.employee_advance_item_detail,
      employee_advance_detail: [],
      isEdit: false,
      fields: [
        { key: "title", label: "Title", class: "width-250" },
        {
          key: "amount",
          label: "Jumlah",
          class: "width-250",
          sortable: true,
        },
        { key: "action", class: "width-50 text-center" },
      ],
      loadingSubmitModal: false,
    };
  },
  props: {
    isDisable: {
      type: Boolean,
      default: true,
    },
    advanceId: {
      type: String,
      default: "",
    },
    loadingParam: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
    tableDetail: {
      type: Boolean,
      default: true,
    },
    advanceDetailItem: {
      type: [Array],
      default: () => [],
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    employeeAdvanceItemForm: {
      title: { required },
      amount: { required },
      employee_advance_id: {},
    },
  },
  methods: {
    init: function () {
      this.resetForm();
      //this.getEmployeeAdvance();
    },
    reload(advance_id) {
      this.$emit("reload", advance_id);
    },
    getEmployeeAdvance: function () {
      this.axios
        .get("web/employee_advance/item-detail/" + this.advanceId)
        .then((response) => {
          this.employee_advance_detail = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.employeeAdvanceItemForm = e;
    },
    resetForm: function () {
      for (var a in _interfaces.employee_advance_item_detail) {
        _interfaces.employee_advance_item_detail[a] = null;
      }
      this.employeeAdvanceItemForm = _interfaces.employee_advance_item_detail;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah pengajuan kasbon ini ?")) {
          this.loadingSubmitModal = true;
          this.employeeAdvanceItemForm.advance_id = this.advanceId;
          this.axios
            .put(
              "web/employee_advance/edit-item-detail/",
              this.employeeAdvanceItemForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Pengajan Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Pengajan Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.$emit("reload", this.advanceId);
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan pengajuan kasbon ini ?")) {
          this.loadingSubmitModal = true;
          this.employeeAdvanceItemForm.advance_id = this.advanceId;
          this.axios
            .post(
              "web/employee_advance/add-item-detail/",
              this.employeeAdvanceItemForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Pengajan Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Pengajan Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.$emit("reload", this.advanceId);
            });
        }
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
